import { Box, Flex, FlexProps, Image } from "@chakra-ui/react"

type SpaceAugmentationIdentityProps = FlexProps & {
  image: string
  name: string
}

function SpaceAugmentationIdentity({
  image,
  name,
  ...props
}: SpaceAugmentationIdentityProps) {
  return (
    <Flex
      borderRadius="50%"
      overflow="hidden"
      pos="relative"
      w="2rem"
      h="2rem"
      {...props}
    >
      {/* White bg with inset of 1px to avoid slight visual overflow. */}
      <Box
        bg="white"
        pos="absolute"
        inset="1px"
        borderRadius="50%"
        overflow="hidden"
      />
      <Image src={image!} alt={name} pos="absolute" inset={0} />
    </Flex>
  )
}

export default SpaceAugmentationIdentity
